import React from 'react';
import Transition from 'react-transition-group/Transition';
import classNameBind from 'classnames/bind';
import Icon from '../../Icon';
import Label from '../../Label';
import styles from '../Accordion.module.css';

const bindClasses = classNameBind.bind(styles);

const AccordionStateless = ({
  onClick,
  text,
  selected,
  withBorder,
  subdued,
  renderOnOpen,
  hideSeparator,
  noPadding,
  disabled,
  children,
}) => (
  <div
    className={bindClasses('element', { withBorder, subdued, hideSeparator, noPadding, disabled })}
    data-ppuc-id="Accordion"
  >
    <div
      className={bindClasses('button')}
      role="button"
      tabIndex={0}
      onClick={() => { if (!disabled) onClick(); }}
      data-ppuc-id="Accordion.button"
    >
      <div className={bindClasses('label-container')}>
        <Icon
          name="chevron-right"
          className={bindClasses(
            'rotate',
            {
              'rotate-down': selected,
              'rotate-up': !selected,
            },
          )}
        />
        {typeof text === 'string'
          ? (<Label type="large">{text}</Label>)
          : (<div className={bindClasses('custom-title')}>{ text }</div>)
                }
      </div>
    </div>
    <Transition in={selected} timeout={0}>
      {status => (
        <div
          className={bindClasses('content', `content-${status}`)}
          data-ppuc-id="Accordion.content"
        >
          {((selected && renderOnOpen) || !renderOnOpen) && children}
        </div>
      )}
    </Transition>
  </div>
);

AccordionStateless.defaultProps = {
  text: '',
  children: null,
  selected: false,
  withBorder: false,
  subdued: false,
  renderOnOpen: false,
  hideSeparator: false,
  noPadding: false,
  disabled: false,
  onClick: () => {},
};

export default AccordionStateless;
